import type { FacebookCredentials } from '@kimuno/api-sdk';

import api from '../clients/api';
import { notifyBugsnagNetwork } from '../utils/bugsnagClient';

const service = {
	loginKeycloakUser,
	login,
	loginFB,
	logout,
	validateCaptcha,
};

function login(username: string, password: string) {
	notifyBugsnagNetwork('auth', 'login', { username, password: !!password });
	return api.auth.login({ username, password });
}

function loginKeycloakUser(code: string) {
	notifyBugsnagNetwork('auth', 'keycloakLogin', { code: !!code });
	return api.auth.keycloakLogin(code);
}

function loginFB(
	facebookId: string,
	facebookToken: string,
	tracking: FacebookCredentials['tracking']
) {
	notifyBugsnagNetwork('auth', 'loginFB', {
		facebookId,
		facebookToken: facebookToken.substr(0, 3),
	});

	return api.auth.facebookLogin({ facebookId, facebookToken, tracking });
}

function logout() {
	notifyBugsnagNetwork('auth', 'logout');
	return api.auth.logout();
}

function validateCaptcha(solution: string, sitekey: string) {
	notifyBugsnagNetwork('auth', 'validateCaptcha');
	return api.auth.validateCaptcha({ solution, sitekey });
}

export default service;
